/*
 * Created on Mon Nov 19 2018
 *
 * Copyright (c) 2018 - Francisco Giana <gianafrancisco@gmail.com>
 */
import { Injectable } from '@angular/core';

@Injectable()
export class AuthStatusGuard {

    public isLogged() {
        if (sessionStorage.getItem('currentUser')) {
            return true;
        }
        return false;
    }
}
